import { RequestConfig } from '@/interface'

const PRIFIX = 'ypgl/dkgx/'
const deductionCheckConfig: RequestConfig = {
  // 抵扣勾选
  dkgx: {
    url: `${PRIFIX}dkgx`,
    method: 'post'
  },
  // 海关缴款书
  dkgxHgjkslb: {
    url: `${PRIFIX}dkgxHgjkslb`,
    method: 'post'
  },
  // 代扣代缴完税凭证列表
  dkgxDkdjwspzlb: {
    url: `${PRIFIX}dkgxDkdjwspzlb`,
    method: 'post'
  },
  // 发票数据概览
  fpsjgl: {
    url: `${PRIFIX}dkgxFpsjgl`,
    method: 'get'
  },
  // 抵扣结果
  dkgxjg: {
    url: `${PRIFIX}dkgxjg`,
    method: 'get'
  },
  // 勾选统计
  gxtj: {
    url: `${PRIFIX}gxtj`,
    method: 'get'
  },
  // 撤销统计确认
  cxtjqr: {
    url: `${PRIFIX}cxtjqr`,
    method: 'post'
  },
  // 勾选统计结果
  gxtjJg: {
    url: `${PRIFIX}gxtjJg`,
    method: 'get'
  },
  tjqrExportExcel: {
    url: `${PRIFIX}exportExcel`,
    method: 'post'
  },
  // 首页统计
  tj: {
    url: `${PRIFIX}tj`,
    method: 'post'
  },
  // 首页接入企业统计
  jrqytj: {
    url: `${PRIFIX}dkgxjrqytj`,
    method: 'get'
  },
  // 统计确认明细
  tjqrmx: {
    url: `${PRIFIX}dkgxTjqrmx`,
    method: 'post'
  },
  // 撤销异常凭证勾选
  qxycpzgx: {
    url: `${PRIFIX}qxycpzgx`,
    method: 'post'
  },
  // 当前企业税款所属期
  qydqssqxx: {
    url: `${PRIFIX}dkgxQydqssqxx`,
    method: 'get'
  },
  // 企业当前所属期后台计算
  qydqssqxxjs: {
    url: `${PRIFIX}dkgxQydqssqxxjs`,
    method: 'post'
  },
  // 企业当前所属期信息设置
  qydqssqxxsz: {
    url: `${PRIFIX}dkgxQydqssqxx`,
    method: 'post'
  },
  // 刷新申报状态
  sxsbzt: {
    url: `${PRIFIX}dkgxSxsbzt`,
    method: 'get'
  },
  // 勾选海关缴款书导入
  gxhgjksdr: {
    url: `${PRIFIX}gxhgjksdr`,
    method: 'post'
  },
  // 勾选代扣代缴完税凭证导入
  gxdkdjdr: {
    url: `${PRIFIX}gxdkdjdr`,
    method: 'post'
  },
  // 勾选发票导入
  gxfpdr: {
    url: `${PRIFIX}gxfpdr`,
    method: 'post'
  },
  // 提交统计确认
  tjtjqr: {
    url: `${PRIFIX}tjtjqr`,
    method: 'post'
  },
  // 异常发票分页
  ycfpxxPage: {
    url: `${PRIFIX}ycfpxx/page`,
    method: 'post'
  },
  // 异常发票导出
  ycfpxxExport: {
    url: `${PRIFIX}ycfpxx/export`,
    method: 'post'
  },
  // 异常海关缴款书分页
  ychgjksPage: {
    url: `${PRIFIX}ychgjks/page`,
    method: 'post'
  },
  // 异常海关缴款书导出
  ychgjksExport: {
    url: `${PRIFIX}ychgjks/export`,
    method: 'post'
  },
  // 税款所属期变更
  dkgxBgskssq: {
    url: `${PRIFIX}dkgxBgskssq`,
    method: 'post'
  },
  // 刷新税款所属期
  dkgxSxsbzt: {
    url: `${PRIFIX}dkgxSxsbzt`,
    method: 'post'
  }
}
export default deductionCheckConfig
